import { adminPanelRoutes } from "./adminPanelRoutes";
import { mainRoutes } from "./mainRoutes";
import { studentPanelRoutes } from "./studentPanelRoutes";

export const routes = [
  ...mainRoutes,
  ...adminPanelRoutes,
  ...studentPanelRoutes,
];
